export enum PortfolioType {
    AutoInvest = 'auto_invest',
    ManualInvest = 'manual_invest',
    HybridInvest = 'hybrid_invest',
    Reinvest = 'reinvest',
    FinzyBolt = 'finzy_bolt'
}